import Box from '@sendsprint/ui-react/dist/components/Box';
import Button from '@sendsprint/ui-react/dist/components/Button';
import Icon from '@sendsprint/ui-react/dist/components/Icon';
import MinusCircleOutline from '@sendsprint/ui-react/dist/icons/MinusCircleOutline';
import PlusCircleOutline from '@sendsprint/ui-react/dist/icons/PlusCircleOutline';
import React from 'react';

interface Props {
  handleMinusClick: () => void;
  handlePlusClick: () => void;
  quantity: number | string;
}

const Quantity = ({ handleMinusClick, handlePlusClick, quantity }: Props) => {
  return (
    <Box className="ss-flex ss-items-center ss-gap-3">
      <Button
        disabled={Number(quantity) < 2}
        variant="secondary"
        onClick={handleMinusClick}
        className="ss-rounded-full ss-w-10 ss-h-10 !ss-p-0"
        label={<Icon size={24} svg={MinusCircleOutline} />}
      />
      <input
        value={quantity}
        disabled
        className="ss-border ss-text-paragraph-regular ss-px-4 ss-rounded-base ss-block focus:ss-focus-ring ss-bg-neutral-100 ss-placeholder-neutral-400 ss-text-neutral-500 ss-border-neutral-300 hover:ss-border-primary1-500 focus:ss-border-primary1-50 ss-w-14 ss-pl-5 ss-h-10 ss-cursor-not-allowed"
      />
      <Button
        variant="secondary"
        onClick={handlePlusClick}
        className="ss-rounded-full ss-w-10 ss-h-10 !ss-p-0"
        label={<Icon size={24} svg={PlusCircleOutline} />}
      />
    </Box>
  );
};

export default Quantity;
